import React from 'react';
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip
} from 'recharts';

interface SimpleLineChartProps {
  data: any[];
  type: "messages" | "revenue";
}

export const SimpleLineChart: React.FC<SimpleLineChartProps> = ({ data, type }) => {
  const dataKey = type === "messages" ? "total" : "revenue";
  const color = type === "messages" ? "#3B82F6" : "#10B981";

  return (
    <div className="h-72 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="colorFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={color} stopOpacity={0.3} />
              <stop offset="95%" stopColor={color} stopOpacity={0.05} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip
            formatter={(value: number) =>
              type === "revenue" ? `$${value.toLocaleString()}` : value.toLocaleString()
            }
            labelFormatter={(label) => label}
            contentStyle={{ borderRadius: 8, borderColor: '#ccc' }}
          />
          <Area
            type="monotone"
            dataKey={dataKey}
            stroke={color}
            fillOpacity={1}
            fill="url(#colorFill)"
            strokeWidth={2}
            activeDot={{ r: 5 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};
